import React from 'react'
import { connect } from 'react-redux'
import { Tabs, Tab, Paper, Typography, Box } from '@material-ui/core'
import ProductionRatesTable from './ProductionRatesTable'
import LaborRatesTable from './LaborRatesTable'
import EquipmentRatesTable from './EquipmentRatesTable'
import MaterialCatalogTable from './MaterialCatalogTable'

const TabPanel = ({ children, value, index }) => {
  if (value !== index) return null
  return (
    <Box p={2}>
      {children}
    </Box>
  )
}

const RateTablesView = (props) => {
  const [tab, setTab] = React.useState(0)

  return (
    <div style={{ padding: 20 }}>
      <Typography variant="h5" style={{ marginBottom: 16 }}>
        Rate Tables
      </Typography>
      <Paper>
        <Tabs
          value={tab}
          onChange={(e, newVal) => setTab(newVal)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Production Rates" />
          <Tab label="Labor Rates" />
          <Tab label="Equipment Rates" />
          <Tab label="Material Catalog" />
        </Tabs>
        <TabPanel value={tab} index={0}>
          <ProductionRatesTable url={props.url} />
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <LaborRatesTable url={props.url} />
        </TabPanel>
        <TabPanel value={tab} index={2}>
          <EquipmentRatesTable url={props.url} />
        </TabPanel>
        <TabPanel value={tab} index={3}>
          <MaterialCatalogTable url={props.url} />
        </TabPanel>
      </Paper>
    </div>
  )
}

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user,
  authenticated: state.authenticated
})

export default connect(mapStateToProps)(RateTablesView)
